import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/repo/public/assets/footerIcons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/root/repo/public/assets/footerIcons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/root/repo/public/assets/footerIcons/linkedin.svg");
